/** Normalizza solo l'input dell'editor; un prezzo riservato può essere assente. */
export function normalizeEditorPrice(value: unknown, onRequest: boolean): number | null {
  if (value === '' || value === null || value === undefined ||
      (typeof value === 'number' && Number.isNaN(value))) {
    if (onRequest) return null;
    throw new Error('Inserisci un prezzo valido oppure seleziona Trattativa riservata');
  }
  const price = typeof value === 'string' ? Number(value) : value;
  if (typeof price !== 'number' || !Number.isFinite(price) || price <= 0) {
    throw new Error('Il prezzo deve essere un numero maggiore di zero');
  }
  return price;
}
